import { ref } from 'vue'

export function useToggle() {
	let isFull = ref(false)
	let navbar = document.getElementById("navbar")
	let wrapper = document.getElementById("wrapper")

	function show() {
		navbar.classList.remove('active-default')
		wrapper.classList.remove('active-default')
	}
	
	function hide() {
		navbar.classList.add('active-default')
		wrapper.classList.add('active-default')
	}

	function toggle() {
		isFull.value === true ? hide() : show()
	}

	return {
		isFull,
		show,
		hide,
		toggle,
	}
}